<template>
  <div class="card p-3">
    <div class="card-block">
      <vs-row>
        <vs-col w="12">
            <vs-button
            flat
            href="/panel-docentes"
            >
            Ir a home
            </vs-button>
            <h4 class="mt-4 p-2">Carga de material</h4>
        </vs-col>
        <vs-col w="12">
            <form autocomplete="off" @submit.prevent="getBusqueda()">
                <vs-row>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="cicloEscolar" class="labelInput">
                                Ciclo Escolar
                            </label>
                            <vs-select class="aqui pt-0" id="cicloEscolar" placeholder="Seleccionar Ciclo Escolar" :key="cicloId" v-model="cicloEscolar" :disabled="!ciclosEscolares.length" @input="changeInfo('ciclo')">
                                <vs-option v-for="option in ciclosEscolares" :key="option.id"  :label="option.nombre_ciclo" :value="option.id">
                                    {{option.nombre_ciclo}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="institucion" class="labelInput">
                                Institución
                            </label>
                            <vs-select :loading="loadingInstitucion" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institucion" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" @input="changeInfo('institucion')">
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="programa" class="labelInput">
                                Programa
                            </label>
                            <vs-select :loading="loadingPrograma" class="aqui pt-0" id="programa" placeholder="Seleccionar Programa" :key="programaId" v-model="programa" :disabled="!programas.length" @input="changeInfo('programa')">
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="periodo" class="labelInput">
                                Periodo
                            </label>
                            <vs-select :loading="loadingPeriodo" class="aqui pt-0" id="periodo" placeholder="Seleccionar Programa" :key="periodoId" v-model="periodo" :disabled="!periodos.length" @input="changeInfo('periodo'), getGrupoAcademicoL()">
                                <vs-option v-for="option in periodos" :key="option.detalle_componente_id"  :label="option.nombre" :value="option.detalle_componente_id">
                                    {{option.nombre}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="codigo" class="labelInput">
                                Código de sesión
                            </label>
                            <vs-select :loading="loadingCodigo" class="aqui pt-0" id="codigo" placeholder="Seleccionar Código de sesión" :key="codigoId" v-model="codigo" :disabled="!codigos.length" @input="changeInfo('codigo')">
                                <vs-option v-for="option in codigos" :key="option.codigo_sesion_id"  :label="option.asignatura" :value="option.codigo_sesion_id">
                                    {{option.asignatura}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col sm="12" lg="3">
                        <form autocomplete="off">
                            <label for="materia" class="labelInput">
                                Grupo académico
                            </label>
                            <vs-select :loading="loadingGrupoAcademicos" class="aqui pt-0" id="grupo" placeholder="Seleccionar Grupo académico" :key="grupoAcademicoId" v-model="grupo_academico" :disabled="!grupos_academicos.length" >
                                <vs-option v-for="option in grupos_academicos" :key="option.id"  :label="option.nombre" :value="option.id">
                                    {{option.nombre}}
                                </vs-option>
                            </vs-select>
                        </form>
                    </vs-col>
                    <vs-col>
                        <vs-button
                            class="ml-auto"
                            @click="getBusqueda()"
                        >
                            <i class="fas fa-search mr-2"></i> Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </form>
        </vs-col>
        <vs-col w="12" class="mt-4" v-if="alumnos.length">
            <tabla-carga-materiales :users="alumnos" :documentosGenerales="documentosGenerales" :filtrosPadres="filtrosPadres" @refreshTable="getAlumnoListaMaterial"></tabla-carga-materiales>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>

import evaluaciones from '../../../api/requests/docente/evaluaciones.js'
import TablaCargaMateriales from './tabla-carga-material.vue'
import TablaDocumentosGenerales from './tabla-documentos-generales.vue'
export default {
  props: [ 'csrf_token' ],
  data() {
    return {
      cicloEscolar: '',
      ciclosEscolares: [],
      cicloId: (new Date()).getTime(),
      loadingCiclo: false,
      institucion: '',
      instituciones: [],
      institucionId: (new Date()).getTime(),
      loadingInstitucion: false,
      programa: '',
      programas: [],
      programaId: (new Date()).getTime(),
      loadingPrograma: false,
      periodo: '',
      periodos: [],
      periodoId: (new Date()).getTime(),
      loadingPeriodo: false,
      codigo: '',
      codigos: [],
      codigoId: (new Date()).getTime(),
      loadingCodigo: false,
      grupo_academico: '',
      grupos_academicos: [],
      grupoAcademicoId: (new Date()).getTime(),
      loadingGrupoAcademicos: false,
      users:[],
      sabana:[],
      modoCaptura: '',
      modoLista: '',
      modoSabana: '',
      parametros: [],
      documentosGenerales: [],
      alumnos: [],
      filtrosPadres: {}
    }
  },
  components: { 
    TablaCargaMateriales,
    TablaDocumentosGenerales
  },
  async created() {
    this.getciclosEscolaresDocente()
  },
  methods: {
    changeInfo(valor){
      if(valor == 'ciclo'){
        this.institucion = ''
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupo_academico = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'institucion'){
        this.programa = ''
        this.periodo = ''
        this.codigo = ''
        this.grupo_academico = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'programa'){
        this.periodo = ''
        this.codigo = ''
        this.grupo_academico = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'periodo'){
        this.codigo = ''
        this.getCodigoSesion()
        this.grupo_academico = ''
        this.users = []
        this.sabana = []
      }
      if(valor == 'codigo'){
        this.grupo_academico = ''
        this.users = []
        this.sabana = []
      }
    },
    async getciclosEscolaresDocente(){
      try {
          const { data: response } = await evaluaciones.getciclosEscolaresDocente()
          this.ciclosEscolares = response
          this.cicloId = (new Date()).getTime()
      }
      catch{

      }
    },
    async getInstitucionDocente(){
      try {
          this.loadingInstitucion = true
          const { data: response } = await evaluaciones.getInstitucionDocente()
          this.instituciones = response
          this.institucionId = (new Date()).getTime()
          this.loadingInstitucion = false
      }
      catch{

      }
    },
    async getProgramaDocentes(){
      try {
        this.loadingPrograma = true
        const params = {
          ciclo_escolar_id: this.cicloEscolar,
          institucion_id: this.institucion
        }
          const { data: response } = await evaluaciones.getProgramaDocentes(params)
          this.programas = response
          this.programaId = (new Date()).getTime()
         this.loadingPrograma = false
      }
      catch{
         this.loadingPrograma = false
      }
    },
    async getPeriodosDocentes(){
      if(this.programa){
        try {
          this.loadingPeriodo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getPeriodosDocentes(params)
          this.periodos = response
          this.periodoId = (new Date()).getTime()
          this.loadingPeriodo = false
        }
        catch{

        }
      }
    },
    async getCodigoSesion(){
      if(this.periodo){
        try {
          this.loadingCodigo = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            institucion_id: this.institucion,
            programa_id: this.programa
          }
          const { data: response } = await evaluaciones.getCodigoSesion(params)
          this.codigos = response
          this.codigoId = (new Date()).getTime()
          this.loadingCodigo = false
        }
        catch{

        }
      }
    },
    async getGrupoAcademicoL(){
      if(this.codigo){
        try {
          this.loadingGrupoAcademicos = true
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            codigo_sesion_id: this.codigo,
            detalle_componente_id: this.periodo
          }
          const { data: response } = await evaluaciones.getGrupoAcademicoL(params)
          this.grupos_academicos = response
          this.grupoAcademicoId = (new Date()).getTime()
          this.loadingGrupoAcademicos = false
        }
        catch{

        }
      }
    },
    getBusqueda(){
      this.getAlumnoListaMaterial()
      // this.getMaterialGeneral()
    },
    async getAlumnoListaMaterial(){
        this.alumnos = []
        const loading = this.$vs.loading()
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            bloque_academico_id: this.grupo_academico,
            codigo_session_id: this.codigo,
            periodo_id: this.periodo
          }
          const {data: response} = await evaluaciones.getAlumnoListaMaterial(params)
          this.alumnos = this.getEliminarNameKey(response)
          this.filtrosPadres = {
            cicloEscolar: this.cicloEscolar,
            bloque_academico: this.grupo_academico,
            codigo_sesion: this.codigo,
            periodo: this.periodo
          }
          loading.close()
        }
        catch{
          loading.close()
        }
    },
    async getMaterialGeneral(){
        this.documentosGenerales = []
        const loading = this.$vs.loading()
        try {
          const params = {
            ciclo_escolar_id: this.cicloEscolar,
            bloque_academico_id: this.grupo_academico,
            codigo_session_id: this.codigo,
            periodo_id: this.periodo
          }
          const {data: response} = await evaluaciones.getMaterialGeneral(params)
          this.documentosGenerales = response.data
          loading.close()
        }
        catch{
          loading.close()
        }
    },
    getEliminarNameKey(info){
        const datos = Object.values(info)
        return datos
    },
  },
  watch: {
    cicloEscolar(){
      this.getInstitucionDocente()
    },
    institucion(){
      this.getProgramaDocentes()
    },
    programa(){
      this.getPeriodosDocentes()
    },
    periodo(){
      this.getGrupoAcademicoL()
    },
    codigo(){
        this.getGrupoAcademicoL()
    },
    grupo_academico(){
      this.getBusqueda()
    }
  }
}
</script>

<style>
.toolbar {
  background-color: white;
  position: sticky;
  top: 0;
}
</style>

<style lang="scss" scoped>
.divAqui {
  height: 800px;
  max-width: 100vw;
  overflow-x: auto;
  overflow-y: auto;
  position: relative;
  margin-top: 100px;
}

table {
  border-collapse: collapse;
  color: lightgrey;
  table-layout: fixed;
}

thead {
  // thead and tr don't currently support sticky
  // position: -webkit-sticky;
  // position: sticky;
  // left: 0; top: 0;
  
  th {
    position: -webkit-sticky; // for safari
    position: sticky;
    top: 0; left: 0;
    
    
    &:first-child {
      z-index: 3;
    }
  }
}

th, td {
  padding: 10px 100px;
  text-transform: capitalize;
}

th {
  background: black;
  color: white;
  white-space: nowrap;
}

tr {
  background: hsl(0, 0%, 20%);
  
  &:nth-child(even) {
    background: hsl(0, 0%, 15%);
  }
  
  &:not(:last-of-type) {
    border-bottom: 2px solid rgba(yellow, 0.25);
  }
}

th, td {
  &:first-child {
    position: -webkit-sticky; // for safari
    position: sticky;
    left: 0px;
    // top: 0px; -> doesn't work in Safari 11
    /*
      thanks to https://github.com/jonjohnjohnson
      explanation: https://github.com/w3c/csswg-drafts/issues/865 
    */
    z-index: 2;
    width: 200px;
  }
}
  
td:first-child {
  tr:nth-child(odd) & {
    background: hsl(0, 0%, 20%);
    box-shadow: inset -2px 0px rgba(black, 0.25);
  }

  tr:nth-child(even) & {
    background: hsl(0, 0%, 15%);
    box-shadow: inset -2px 0px rgba(black, 0.25);
  }
}
</style>

